// extracted by mini-css-extract-plugin
module.exports = {"chatEveryoneImg":"ChatWithEveryone_chatEveryoneImg__1KoEc","closeDiv":"ChatWithEveryone_closeDiv__3VRBp"};